module.exports = __webpack_public_path__ + "static/media/mokup-ui.8c459fcb.jpg";